import React from 'react'
import Navbar from '../navbar/Navbar'
import TitleInfo from '../titleInfo/TitleInfo'
import TrustedBy from '../TrustedBy/TrustedBy'
import Foot from '../footer/Foot'
import ContactUs from '../footer/ContactUs'
import Service from '../Servic/Service'
import Team from '../team/Team'
import Email from '../email/Email'
const Main = () => {
  return (
    <>
      <section id='home'>
        <Navbar></Navbar>
      </section>
      <TitleInfo></TitleInfo>
      <section id='service'>
        <Service></Service>
      </section>
      <section id="email">
        <Email></Email>
      </section>
      <section id='trust'>
        <TrustedBy></TrustedBy>
      </section>
      <Foot></Foot>
    </>
  )
}

export default Main